import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0851c63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Culture" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "企业文化"),
  /*#__PURE__*/_createElementVNode("span", { class: "caption-en" }, "CORPORATE CULTURE")
], -1))
const _hoisted_3 = { class: "culture-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "culture-content-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "culture-left-up" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", null, "愿景"),
      /*#__PURE__*/_createElementVNode("p", null, "让不良资产处置变得简单")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "culture-left-bottom" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", null, "使命"),
      /*#__PURE__*/_createElementVNode("p", null, "看见并重塑看不见的价值")
    ])
  ])
], -1))
const _hoisted_5 = { class: "culture-content-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "价值观", -1))
const _hoisted_7 = { class: "culture-right-desc" }
const _hoisted_8 = ["src"]


export default {
  setup(__props) {

// import { reactive } from 'vue'
// const culture = reactive([
//   {
//     title: '正直',
//     en: 'Integrity',
//     desc: '行事磊落，忠于职责有担当'
//   }, {
//     title: '自省',
//     en: 'Introspection',
//     desc: '保持谦逊不自满，检视自我多复盘'
//   }, {
//     title: '共享',
//     en: 'Sharing',
//     desc: '乐于分享，成就他人才能成就自己 '
//   }, {
//     title: '好奇',
//     en: 'Curiosity',
//     desc: '保持好奇，才能不断进步'
//   }, {
//     title: '极致',
//     en: 'Excellent',
//     desc: '精益求精，匠人匠心'
//   }, {
//     title: '快速 ',
//     en: 'Fast',
//     desc: '用强大的执行力快速实现目标 '
//   }, {
//     title: '尊重',
//     en: 'Respect',
//     desc: '换位思考，尊重自己的选择、尊重伙伴和客户'
//   }, {
//     title: '审慎',
//     en: 'Cautious',
//     desc: '心存敬畏、行有所止 '
//   }, {
//     title: '专业',
//     en: 'Professional',
//     desc: '专业是个人和团队最好的名片'
//   }
// ])

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "right-cell"
            }, [
              _createElementVNode("img", {
                src: require('img/about/culture/1'+(index+1)+'.png')
              }, null, 8, _hoisted_8)
            ])
          }), 64))
        ])
      ])
    ])
  ]))
}
}

}